import styled from "@emotion/styled";
import { colors, mq } from "@/styling";
import type { Styles } from "@/types";

const FullWidthContainer = styled("div")(
  {
    height: "100%",
    backgroundColor: colors.lightGrey,

    "@media print": {
      backgroundColor: "transparent",
    },
  },
  mq({
    padding: ["30px 10px", "40px 10px", "50px 10px"],
  }),
  ({ styles }: { styles?: Styles }) => ({ ...styles })
);

const MaxWidthContainer = styled("div")(
  {
    maxWidth: 1180,
    margin: "0 auto",
    position: "relative",
  },
  ({ styles }: { styles?: Styles }) => ({ ...styles })
);

export { FullWidthContainer, MaxWidthContainer };
